import { Injectable } from '@angular/core'
import { DefaultOptions } from '@apollo/client/core';
import { environment } from '@environment/environment';
import { Apollo, ApolloBase } from 'apollo-angular';
import { SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
//import {WebSocketLink} from '@apollo/client/link/ws';
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { Client, ClientOptions, createClient } from "graphql-ws";
import {ApolloClientOptions, InMemoryCache, split} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import { v4 as uuid } from 'uuid';


const hasuraWss = environment.config.hasuraWss;
const hasuraUrl = environment.config.hasuraUrl;

//to use graphql-ws
interface RestartableClient extends Client {
  restart(): void;
}


@Injectable({
  providedIn: 'root',
})
export class HasuraService {
  private isLoaded$$: BehaviorSubject<boolean>;
  private isLoaded: boolean = false;


  private defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }

  constructor(
    private sessionStorage: SessionStorageService,
    private apollo: Apollo,
    private httpLink: HttpLink,
  ) {

    this.isLoaded$$ = new BehaviorSubject(this.isLoaded);

  }

  init(): void {

    if (!this.isLoaded) {
      this.createClients();
    }
  }

  isLoaded$(): Observable<boolean> {
    return this.isLoaded$$.asObservable();
  }

  private createClients() {

    const agentId = this.sessionStorage.retrieve('agentId');
    const idGenerator = () => `${agentId}_${uuid()}`;

    // normal
    /* ********************************************************************** */
    // let normalLink = this.httpLink.create({ uri: hasuraUrl });

    // const middleware = new ApolloLink((operation, forward) => {

    //   const userToken = this.sessionStorage.retrieve('userToken');
    //   if (userToken !== null && userToken !== ""){
    //     operation.setContext({
    //       headers: new HttpHeaders().set(
    //         'Authorization',
    //         `Bearer ${userToken}`,
    //       ),
    //     });
    //   }

    //   return forward(operation);
    // });

    // const link = middleware.concat(normalLink)

    // this.apollo.createNamed(
    //   'normal',
    //   {
    //     link: link,
    //     cache: new InMemoryCache(),
    //     defaultOptions: this.defaultOptions,
    //     connectToDevTools: true
    //   }
    // );
    /* ********************************************************************** */

    // wss
    /* ********************************************************************** */
    const wsConnParam = () => {
      const userToken = this.sessionStorage.retrieve('userToken') ?? null;

      const ret = (userToken)
        ? {
          headers: {
            "Authorization": `Bearer ${userToken}`,
          }
        }
        : null;

      return ret;

    };

    //to use graphql-ws
    const wsConnParam2 = () => {
      const userToken = this.sessionStorage.retrieve('userToken') ?? null;

      const ret = (userToken)
        ? {          
          headers:{
            Authorization: `Bearer ${userToken}`
            // "x-hasura-admin-secret":"xxxxxxxx"
          }   
        }
        : {};

      return ret;

    };

    //to use graphql-ws
    let wsLink2 = new GraphQLWsLink(
      this.createRestartableClient({
        url: hasuraWss,
        generateID: () => idGenerator(),
        connectionParams: wsConnParam2
      }),
    );

    this.apollo.createNamed(
      'subs_anon',     
      {
        link: wsLink2,
        cache: new InMemoryCache(),
        defaultOptions: this.defaultOptions,
        connectToDevTools: !environment.production,
      }
    );

    /* ********************************************************************** */


    this.isLoaded = true;
    this.isLoaded$$.next(this.isLoaded);
    console.log("===========", "Hasura service loaded.");

  }

  private createClientAuth(): ApolloBase<any> {

    const userToken = this.sessionStorage.retrieve('userToken');
    const agentId = this.sessionStorage.retrieve('agentId');
    const idGenerator = () => `${agentId}_${uuid()}`;

    // let wsLink = new WebSocketLink({
    //   uri: hasuraWss,
    //   options: {
    //     reconnect: true,
    //     connectionParams: {
    //       headers: {
    //         "Authorization": `Bearer ${userToken}`,
    //       }
    //     }
    //   }
    // });

    //to use graphql-ws
    let wsLink2 = new GraphQLWsLink(
      this.createRestartableClient({
        url: hasuraWss,
        generateID: () => idGenerator(),
        connectionParams: {
          headers:{
            Authorization: `Bearer ${userToken}`
            // "x-hasura-admin-secret":"xxxxxxxx"
          }          
        }
      }),      
    );


    this.apollo.createNamed(
      'subs_auth',
      {
        link: wsLink2,
        cache: new InMemoryCache(),
        defaultOptions: this.defaultOptions,
        connectToDevTools: !environment.production,
      }
    );

    return this.apollo.use('subs_auth');

  }


  public getClient(type?: string): ApolloBase<any> {

    let client: ApolloBase<any>;

    if (type == 'subs_anon') {
      client = this.apollo.use('subs_anon');
    }
    else {
      client = this.apollo.use('subs_auth');
      const userToken = this.sessionStorage.retrieve('userToken') ?? null;
      if (userToken) {
        if (!client) {
          client = this.createClientAuth();
        }
      }

    }

    return client;
  }

  //to use graphql-ws
  private createRestartableClient(options: ClientOptions): RestartableClient {
    let restartRequested = false;
    let restart = () => {
      restartRequested = true;
    };
   
    const client = createClient({
      ...options,      
      on: {
        ...options.on,
        opened: (socket:any) => {
          options.on?.opened?.(socket);
   
          restart = () => {
            if (socket.readyState === WebSocket.OPEN) {
              // if the socket is still open for the restart, do the restart
              socket.close(4205, 'Client Restart');
            } else {
              // otherwise the socket might've closed, indicate that you want
              // a restart on the next opened event
              restartRequested = true;
            }
          };
   
          // just in case you were eager to restart
          if (restartRequested) {
            restartRequested = false;
            restart();
          }
        },
      },
    });
   
    return {
      ...client,
      restart: () => restart(),
    };
  }

  

}
